import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

import VideoHelpers from 'video/scripts/video-helpers';
import PlayerBridge from './players/player-bridge';
import YoutubeWrapper from './players/youtube-wrapper';
import VimeoWrapper from './players/vimeo-wrapper';


Snappy.Component.ResponsiveVideo = class ResponsiveVideo extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-responsive-video';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.init();
    }

    setVars() {
        this.player = null;
        this.$thumbnailNode = this.$element.find('.js-rv-thumbnail');
        this.$videoNode = this.$element.find('.js-rv-video');
        this.$durationNode = this.$element.find('.js-rv-duration');
        this.caption = this.$element.data('videoCaption');
        this.videoUrl = this.$element.data('videoUrl');
        this.currentSection = this.$element.data('currentSection');
        this.isTracked = false;
        this.videoHost = this.detectVideoHost();
        this.videoId = this.getVideoId();

    }

    setEventListeners() {
        $(document).on('responsiveVideo:stopVideo', this.onEventStopVideo.bind(this));
        this.$thumbnailNode.on('click', this.onClickThumbnailHandler.bind(this));
    }

    init() {

        this.playerBridge = new PlayerBridge();

        const options = {
            videoNode: this.$videoNode[0],
            videoId: this.videoId,
            videoUrl: this.videoUrl,
            onReadyCallback: this.onPlayerReadyCallback.bind(this),
            onPlayCallback: this.onPlayCallback.bind(this)
        };

        let playerWrapper;

        if (this.videoHost === 'youtube') {
            playerWrapper = new YoutubeWrapper();

        } else if (this.videoHost === 'vimeo') {
            playerWrapper = new VimeoWrapper();
        }

        this.playerBridge.setImplementation(playerWrapper);
        this.playerBridge.initPlayer(options);

        if (this.$durationNode.length) {
            this.updateMetaData();
        }

    }

    onPlayerReadyCallback() {
        this.setEventListeners();
    }

    onPlayCallback() {
        this.$thumbnailNode.fadeOut(200);

        if (!this.isTracked) {
            this.trackPlay();

        }
    }

    detectVideoHost() {
        if (this.$element.hasClass('is-vimeo')) {
            return 'vimeo';
        }
        if (this.$element.hasClass('is-youtube')) {
            return 'youtube';
        }

        if (this.videoUrl) {
            return (this.videoUrl.indexOf("youtu") > -1) ? 'youtube' : 'vimeo';
        }

        return 'youtube';
    }

    getVideoId() {
        if (this.$element.data('videoId')) {
            return this.$element.data('videoId');
        }

        if (this.videoHost === 'youtube' && this.videoUrl) {
            return VideoHelpers.parseYoutubeId(this.videoUrl)
        }

        if (this.videoHost === 'vimeo' && this.videoUrl) {
            return VideoHelpers.parseVimeoId(this.videoUrl)
        }
    }

    async updateMetaData() {
        const duration = await this.playerBridge.getDuration();
        const formattedDuration = VideoHelpers.getFomattedDuration(duration);
        this.$durationNode.text(formattedDuration);

    }

    onEventStopVideo() {
        this.playerBridge.stop();
    }

    trackPlay() {
        this.isTracked = true;
        if (this.$body.hasClass('eduhub-layout')) {
            this.$window.trigger('gtm:send', [ this.currentSection, 'View Video', `${window.location.href} > ${this.caption}`]);
        } else {
            this.$window.trigger('gtm:send', [ 'Video', 'Play', this.caption]);
        }


    }

    //IE FIX; Doesn't support pointer-events property
    onClickThumbnailHandler(){
        this.$thumbnailNode.fadeOut(200);
        this.playerBridge.play();
    }
};



// WEBPACK FOOTER //
// ./components/responsive-video/scripts/responsive-video.js